import React from 'react';
import { GlobeIcon, InstagramIcon, LinkedinIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { Logo } from '../Logo';
import { LanguageSwitcher } from '../LanguageSwitcher';
import { useLanguage } from '../../contexts/LanguageContext';
import { email, phones, website } from '../../data/contact';
const socials = [{
  label: 'LinkedIn',
  Icon: LinkedinIcon,
  href: 'https://www.linkedin.com/company/capital-winds-llc/'
}, {
  label: 'Instagram',
  Icon: InstagramIcon,
  href: 'https://www.instagram.com/standardconsultingadvice?igsi=MTQ0djNva3l5Z2w3NA=='
}];
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="border-t border-white/10 bg-ink pb-10 pt-20" data-id="element-125" data-mp="1w826ns98whap">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-126" data-mp="1reh4rp4j7368">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_1fr_1fr_1fr]" data-id="element-127" data-mp="13peq8q571qfy">
          <div data-id="element-128" data-mp="13nk458i6rsaa">
            <Logo variant="light" data-id="element-129" data-mp="yqlbkue67te7" />
            <p className="mt-6 max-w-[300px] text-[14px] leading-relaxed text-white/55" data-id="element-130" data-mp="yrd4tykapf1b">
              {t.footer.tagline}
            </p>
            <div className="mt-7 overflow-hidden rounded-4xl border border-white/10 shadow-lift" data-id="element-131" data-mp="1ehtyhmgr2w76">
              <img src="https://cdn.magicpatterns.com/uploads/9w4R1e9Qm7iDRLUBkjiyMC/WhatsApp_Image_2026-08-19_at_9.39.32_AM.jpg" alt={t.footer.teamPhotoAlt} className="h-[260px] w-full object-cover transition-transform duration-700 hover:scale-[1.04] sm:h-[320px] lg:h-[300px]" data-id="element-132" data-mp="1ihup05h4ixul" />
            </div>
            <ul className="mt-7 flex items-center gap-3" data-id="element-133" data-mp="vl12hig77h95">
              {socials.map(({
              label,
              Icon,
              href
            }) => <li key={label} data-id="element-134" data-mp="14jmue47k88ml">
                  <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="flex h-10 w-10 items-center justify-center rounded-xl border border-white/12 text-white/70 transition-all duration-300 hover:-translate-y-0.5 hover:border-brand hover:bg-brand hover:text-white" data-id="element-135" data-mp="14ibghbkehkhr">
                    <Icon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-136" data-mp="2kwl3o2cwp370" />
                  </a>
                </li>)}
            </ul>
            <LanguageSwitcher variant="dark" className="mt-7 w-fit" data-id="element-137" data-mp="1qaxpc7agsnyy" />
          </div>

          <div data-id="element-138" data-mp="1qd0fqsfj4j47">
            <h3 className="text-[12px] font-semibold uppercase tracking-[0.18em] text-white/40" data-id="element-139" data-mp="2586gp0zrprqo">
              {t.footer.floridaOffice}
            </h3>
            <p className="mt-5 flex gap-2.5 text-[14px] leading-relaxed text-white/70" data-id="element-140" data-mp="209mwb50too0f">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-141" data-mp="1ckapucwvqu1t" />
              <span data-id="element-142" data-mp="17lh9mcq7koxy">
                {t.footer.floridaAddress[0]}
                <br data-id="element-143" data-mp="1m92dw9ytku7g" />
                {t.footer.floridaAddress[1]}
              </span>
            </p>
            <h3 className="mt-8 text-[12px] font-semibold uppercase tracking-[0.18em] text-white/40" data-id="element-144" data-mp="1hivpob87zbpq">
              {t.footer.newYorkOffice}
            </h3>
            <p className="mt-5 flex gap-2.5 text-[14px] leading-relaxed text-white/70" data-id="element-145" data-mp="tr6v0o7xeb5m">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-146" data-mp="otezlk82o6wo" />
              <span data-id="element-147" data-mp="30fpabrpua64r">
                {t.footer.newYorkAddress[0]}
                <br data-id="element-148" data-mp="358ib64i6subk" />
                {t.footer.newYorkAddress[1]}
              </span>
            </p>
          </div>

          <div data-id="element-149" data-mp="2qk5j3im7zvmc">
            <h3 className="text-[12px] font-semibold uppercase tracking-[0.18em] text-white/40" data-id="element-150" data-mp="2qkozuw04wdys">
              {t.footer.contact}
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-151" data-mp="3j81bib4rb1db">
              {phones.map(phone => <li key={phone.href} data-id="element-152" data-mp="3j5ov42encz2d">
                  <a href={phone.href} className="flex items-center gap-2.5 text-[14px] text-white/70 transition-colors hover:text-white" data-id="element-153" data-mp="3o7e7pmhipksk">
                    <PhoneIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-154" data-mp="3a6jw6uz6b3po" />
                    {phone.display}
                  </a>
                </li>)}
              <li data-id="element-155" data-mp="1yretvs2yf76l">
                <a href={`mailto:${email}`} className="flex items-start gap-2.5 break-all text-[14px] text-white/70 transition-colors hover:text-white" data-id="element-156" data-mp="1yqv820a6nyna">
                  <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-157" data-mp="22r6vtlxuef2z" />
                  {email}
                </a>
              </li>
              <li data-id="element-158" data-mp="2e963l3iixbi0">
                <a href={website.href} className="flex items-center gap-2.5 text-[14px] text-white/70 transition-colors hover:text-white" data-id="element-159" data-mp="2e7uxgx1lvrnq">
                  <GlobeIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-160" data-mp="24ca2hiuyfrnh" />
                  {website.display}
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-161" data-mp="2x0fkhxumj2jm">
            <h3 className="text-[12px] font-semibold uppercase tracking-[0.18em] text-white/40" data-id="element-162" data-mp="2wzxkqr8r666y">
              {t.footer.explore}
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-163" data-mp="2rzj9z1froi58">
              {t.nav.links.map(link => <li key={link.href} data-id="element-164" data-mp="2nypmg968l5cv">
                  <a href={link.href} className="text-[14px] text-white/70 transition-colors hover:text-white" data-id="element-165" data-mp="2o1tuxiqqin9c">
                    {link.label}
                  </a>
                </li>)}
              <li data-id="element-166" data-mp="1cjanx0ydq5fn">
                <a href="#consultation" className="text-[14px] font-semibold text-brand transition-colors hover:text-white" data-id="element-167" data-mp="1cmyk67v7l5y2">
                  {t.footer.freeConsultation}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-168" data-mp="126n7mz3g09u">
          <p className="text-[13px] text-white/45" data-id="element-169" data-mp="5v9dnm8kqtlt">
            © {new Date().getFullYear()} {t.footer.rights}
          </p>
          <p className="text-[13px] text-white/45" data-id="element-170" data-mp="fs45jmacdvr4">{t.footer.offices}</p>
        </div>
      </div>
    </footer>;
}